export const skeleTonJson = [
    {
      tokenId: 'loader1',
      tokenName: 'loading',
      icons: null,
      artistId: 'loading',
      nftSaleType: 'loading',
      auctionEndTime: 'loading',
      startingPrice: 'loading',
      price: 'loading',
    },
    {
      tokenId: 'loader2',
      tokenName: 'loading',
      icons: null,
      artistId: 'loading',
      nftSaleType: 'loading',
      auctionEndTime: 'loading',
      startingPrice: 'loading',
      price: 'loading',
    },
    {
      tokenId: 'loader3',
      tokenName: 'loading',
      icons: null,
      artistId: 'loading',
      nftSaleType: 'loading',
      auctionEndTime: 'loading',
      startingPrice: 'loading',
      price: 'loading',
    },
    {
        tokenId: 'loader4',
        tokenName: 'loading',
        icons: null,
        artistId: 'loading',
        nftSaleType: 'loading',
        auctionEndTime: 'loading',
        startingPrice: 'loading',
        price: 'loading',
      },   {
        tokenId: 'loader5',
        tokenName: 'loading',
        icons: null,
        artistId: 'loading',
        nftSaleType: 'loading',
        auctionEndTime: 'loading',
        startingPrice: 'loading',
        price: 'loading',
      },   {
        tokenId: 'loader6',
        tokenName: 'loading',
        icons: null,
        artistId: 'loading',
        nftSaleType: 'loading',
        auctionEndTime: 'loading',
        startingPrice: 'loading',
        price: 'loading',
      },   {
        tokenId: 'loader7',
        tokenName: 'loading',
        icons: null,
        artistId: 'loading',
        nftSaleType: 'loading',
        auctionEndTime: 'loading',
        startingPrice: 'loading',
        price: 'loading',
      },   {
        tokenId: 'loader8',
        tokenName: 'loading',
        icons: null,
        artistId: 'loading',
        nftSaleType: 'loading',
        auctionEndTime: 'loading',
        startingPrice: 'loading',
        price: 'loading',
      },
  ]